import { lazy } from 'react';
import CountryForm from './CountryForm';
import CountryList from './CountryList';

const CountryListConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/countries',
            element: <CountryList />,
        },
        {
            path: '/addCountry',
            element: <CountryForm />,
        },
        {
            path: '/editCountries/:id',
            element: <CountryForm />,
        },
    ],
};

export default CountryListConfig;
